import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from "@emotion/react";
import { useSize } from "@zapier/promotions/esm/hooks";
import { BillingIntervalOption } from "./BillingIntervalOption";
const root = css `
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
`;
const option = (size) => css `
  margin: 16px;
  width: ${size === "small" ? "100%" : "auto"};
`;
export const BillingIntervalOptions = ({ accountCurrency, monthlyIntervalAmount, monthlyPlanId, onSelectPlanId, selectedPlanId, yearlyIntervalAmount, yearlyPlanId, }) => {
    const size = useSize();
    return (_jsxs("div", { css: root, children: [_jsx("span", { css: option(size), children: _jsx(BillingIntervalOption, { accountCurrency: accountCurrency, amount: yearlyIntervalAmount, interval: "year", isSelected: selectedPlanId === yearlyPlanId, onSelect: () => onSelectPlanId(yearlyPlanId) }) }), _jsx("span", { css: option(size), children: _jsx(BillingIntervalOption, { accountCurrency: accountCurrency, amount: monthlyIntervalAmount, interval: "month", isSelected: selectedPlanId === monthlyPlanId, onSelect: () => onSelectPlanId(monthlyPlanId) }) })] }));
};

// @zapier/upsells@5.0.1 (c64b11b3c)
